<template>
  <div class="home_H">
    <el-container>
      <el-main class="main_body" style="padding: 0">
        <div class="foot">
          <div class="foot_div">
            <div class="foot_div_A">
              <div class="foot_div_A_H">拓展业务，从奇迹ip开始</div>
              <div class="foot_div_A_butt">
                <el-button
                    @click="touserlog"
                    class="foot_butt_A"
                    type="primary"
                    round
                >免费试用
                </el-button
                >
              </div>
            </div>
            <div class="foot_div_B">
              <div class="foot_div_B_div">
                <div>
                  <div class="foot_div_B_div_IPDPX">
                    <img
                        style="width: 150px"
                        src="../../assets/logbai.png"
                        alt=""
                    />
                  </div>
                  <div class="gywm_but">
                    <el-button type="text">大客户经理</el-button>
                    <el-button type="text"
                    ><i class="el-icon-phone gywm_but_i"></i>{{ this.$tel }}
                      电话
                    </el-button
                    >
                    <el-button type="text"
                    ><i class="el-icon-message gywm_but_i"></i
                    >{{ this.$email }}
                    </el-button
                    >
                  </div>
                </div>
                <div class="">
                  <div class="foot_HD">关于我们</div>
                  <div class="gywm_but">
                    <el-button type="text" @click="toabout()">公司简介</el-button>
                    <el-button
                        type="text"
                        style="margin-left: 0px"
                        @click="tostatement()"
                    >隐私协议
                    </el-button
                    >
                    <el-button
                        type="text"
                        style="margin-left: 0px"
                        @click="tolaw()"
                    >用户服务协议
                    </el-button
                    >
                  </div>
                </div>
                <!--                -->
                <!--                <div class="">-->
                <!--                  <div class="foot_HD">解决方案</div>-->
                <!--                  <div class="gywm_but">-->
                <!--                    <el-button-->
                <!--                        type="text"-->
                <!--                        style="margin-left: 0px"-->
                <!--                        @click="togetapi('动态住宅代理', '')"-->
                <!--                    >动态住宅代理-->
                <!--                    </el-button-->
                <!--                    >-->
                <!--                    <el-button-->
                <!--                        type="text"-->
                <!--                        style="margin-left: 0px"-->
                <!--                        @click="togetapi('静态住宅代理', '')"-->
                <!--                    >静态住宅代理-->
                <!--                    </el-button-->
                <!--                    >-->
                <!--                    <el-button-->
                <!--                        type="text"-->
                <!--                        style="margin-left: 0px"-->
                <!--                        @click="togetapi('动态ISP代理', '')"-->
                <!--                    >动态ISP代理-->
                <!--                    </el-button-->
                <!--                    >-->
                <!--                    <el-button-->
                <!--                        type="text"-->
                <!--                        style="margin-left: 0px"-->
                <!--                        @click="togetapi('动态数据中心', '')"-->
                <!--                    >动态数据中心-->
                <!--                    </el-button-->
                <!--                    >-->
                <!--                    <el-button-->
                <!--                        type="text"-->
                <!--                        style="margin-left: 0px"-->
                <!--                        @click="togetapi('独享数据中心', '')"-->
                <!--                    >独享数据中心-->
                <!--                    </el-button-->
                <!--                    >-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--               -->
                <div class="">
                  <div class="foot_HD">获取代理</div>
                  <div class="gywm_but">
                    <el-button
                        type="text"
                        style="margin-left: 0px"
                        @click="togetapi('', '产品套餐')"
                    >价格
                    </el-button
                    >
                    <!--                    <el-button-->
                    <!--                        type="text"-->
                    <!--                        style="margin-left: 0px"-->
                    <!--                        @click="togetapi('', 'api提取')"-->
                    <!--                    >API提供-->
                    <!--                    </el-button-->
                    <!--                    >-->
                    <!--                    <el-button-->
                    <!--                        type="text"-->
                    <!--                        style="margin-left: 0px"-->
                    <!--                        @click="togetapi('', '账密认证')"-->
                    <!--                    >账密认证-->
                    <!--                    </el-button-->
                    <!--                    >-->
                  </div>
                </div>
                <!--
                <div class="">
                  <div class="foot_HD">应用场景</div>
                  <div class="yycj_div">
                    <el-button
                      type="text"
                      style="margin-left: 0px"
                      @click="toappll('电子商务')"
                      >电子商务</el-button
                    >
                    <el-button
                      type="text"
                      style="margin-left: 0px"
                      @click="toappll('市场调查')"
                      >市场调查</el-button
                    >
                    <el-button
                      type="text"
                      style="margin-left: 0px"
                      @click="toappll('广告验证')"
                      >广告验证</el-button
                    >
                    <el-button
                      type="text"
                      style="margin-left: 0px"
                      @click="toappll('网站测试')"
                      >网站测试</el-button
                    >
                    <el-button
                      type="text"
                      style="margin-left: 0px"
                      @click="toappll('品牌保护')"
                      >品牌保护</el-button
                    >
                    <el-button
                      type="text"
                      style="margin-left: 0px"
                      @click="toappll('舆情监控')"
                      >舆情监控</el-button
                    >
                    <el-button
                      type="text"
                      style="margin-left: 0px"
                      @click="toappll('SEO优化')"
                      >SEO优化</el-button
                    >
                    <el-button
                      type="text"
                      style="margin-left: 0px"
                      @click="toappll('网页数据采集')"
                      >网页数据采集</el-button
                    >
                    <el-button
                      type="text"
                      style="margin-left: 0px"
                      @click="toappll('社交媒体营销')"
                      >社交媒体营销</el-button
                    >
                    <el-button
                      type="text"
                      style="margin-left: 0px"
                      @click="toappll('旅游信息聚合')"
                      >旅游信息聚合</el-button
                    >
                  </div>
                </div>
                <div class="">
                  <div class="foot_HD">资源</div>
                  <div class="gywm_but">
                    <el-button type="text" style="margin-left: 0px"
                      >语言Demo</el-button
                    >
                    <el-button type="text" style="margin-left: 0px"
                      >帮助中心</el-button
                    >
                    <el-button type="text" style="margin-left: 0px"
                      >资讯中心</el-button
                    >
                    <el-button type="text" style="margin-left: 0px"
                      >合作伙伴</el-button
                    >
                  </div>
                </div>
                -->
              </div>
            </div>
            <div class="foot_div_C">
              <div>
                <div class="foot_div_C_textA">
                  由于政策原因，此服务在中国大陆不可用，不支持访问国内网站
                  ，感谢您的理解
                </div>
                <div class="foot_div_C_textB">
                  © 2024 奇迹ip网络科技有限公司
                  <a
                      style="color: #c6c6c6"
                      href="https://beian.miit.gov.cn/#/Integrated/index"
                  >&nbsp;&nbsp;&nbsp;&nbsp;</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String,
  },
  data() {
    return {};
  },
  components: {},
  mounted() {
  },
  methods: {
    touserlog() {
      this.$router.push({path: "userlogin"});
    },
    toappll(name) {
      if (name === "电子商务") {
        this.$router.push({path: "/apply_electronic"}).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      } else if (name === "市场调查") {
        this.$router.push({path: "/apply_market"}).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      } else if (name === "广告验证") {
        this.$router.push({path: "/apply_advertisement"}).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      } else if (name === "网站测试") {
        this.$router.push({path: "/apply_test"}).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      } else if (name === "品牌保护") {
        this.$router.push({path: "/apply_protect"}).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      } else if (name === "舆情监控") {
        this.$router.push({path: "/apply_seo"}).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      } else if (name === "SEO优化") {
        this.$router.push({path: "/apply_seo"}).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      } else if (name === "网页数据采集") {
        this.$router.push({path: "/apply_collection"}).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      } else if (name === "社交媒体营销") {
        this.$router.push({path: "/apply_media"}).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      } else if (name === "旅游信息聚合") {
        this.$router.push({path: "/apply_travel"}).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      }
    },
    tolaw() {
      this.$router.push({path: "/law"}).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          // 处理其他错误
          console.error(err);
        }
      });
      this.$router.go(0);
    },
    toextension() {
      this.$router.push({path: "/extension"}).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          // 处理其他错误
          console.error(err);
        }
      });
      this.$router.go(0);
    },
    tostatement() {
      this.$router.push({path: "/statement"}).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          // 处理其他错误
          console.error(err);
        }
      });
      this.$router.go(0);
    },
    toabout() {
      this.$router.push({path: "/about"}).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          // 处理其他错误
          console.error(err);
        }
      });
      this.$router.go(0);
    },
    togetapi(name, lable) {
      if (lable === "api提取") {
        this.$router
            .push({path: "/getapi", query: {name: name}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (lable == "账密认证") {
        this.$router
            .push({path: "/getapi", query: {name: name}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (lable == "代理管理器") {
        this.$router
            .push({path: "/getapi", query: {name: name}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (lable == "账密认证") {
        this.$router
            .push({path: "/getapi", query: {name: name}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "更多地区") {
        this.$router.push({path: "/area"}).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      } else if (name == "美国") {
        this.$router
            .push({path: "/area_index", query: {name: "美国"}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "英国") {
        this.$router
            .push({path: "/area_index", query: {name: "英国"}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "加拿大") {
        this.$router
            .push({path: "/area_index", query: {name: "加拿大"}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "泰国") {
        this.$router
            .push({path: "/area_index", query: {name: "泰国"}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "印度") {
        this.$router
            .push({path: "/area_index", query: {name: "印度"}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "马来西亚") {
        this.$router
            .push({path: "/area_index", query: {name: "马来西亚"}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "印度尼西亚") {
        this.$router
            .push({path: "/area_index", query: {name: "印度尼西亚"}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (lable == "额度充值") {
        this.$router
            .push({path: "/pay", query: {name: name, lable: lable}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (lable == "产品套餐") {
        this.$router
            .push({path: "/pay", query: {name: name, lable: lable}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "动态住宅代理") {
        this.$router
            .push({path: "/solution", query: {name: name, lable: lable}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "静态住宅代理") {
        this.$router
            .push({path: "/soluution", query: {name: name, lable: lable}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "动态ISP代理") {
        this.$router
            .push({
              path: "/solution_dynamic",
              query: {name: name, lable: lable},
            })
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "动态数据中心") {
        this.$router
            .push({
              path: "/solution_dynamic_data",
              query: {name: name, lable: lable},
            })
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "独享数据中心") {
        this.$router
            .push({
              path: "/soluution_static",
              query: {name: name, lable: lable},
            })
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      }
    },
  },
};
</script>
<style>
.home_H {
  position: relative;
}

.el-main {
  padding: 0;
}

.foot {
  margin-top: 100px;
}

.foot_div {
  background-color: #20232f;
}

.foot_div_A {
  padding-top: 100px;
  padding-bottom: 100px;
  border-bottom: 1px solid #646266;
}

.foot_div_A_H {
  font-size: 38px;
  font-family: SourceHanSansCN-Medium;
  color: #edf3fc;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: max-content;
  margin: 0 auto;
  letter-spacing: 5px;
  font-weight: 400;
}

.foot_butt_A {
  font-size: 18px;
  font-family: SourceHanSansCN-Bold;
  color: #edf3fc;
  width: 230px;
  background: #6327d3;
  border: none;
  box-shadow: 0 20px 28px 0 rgba(40, 95, 161, 0.29);
  border-radius: 39px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  margin: 40px auto 0;
}

.foot_div_B {
  display: flex;
  justify-content: center;
}

.foot_div_B_div button {
  font-size: 14px;
  font-family: SourceHanSansCN-Light;
  font-weight: 300;
  color: #edf3fc;
}

.foot_div_B_div {
  display: flex;
  width: 75%;
  margin: 32px auto 0;
  justify-content: space-between;
  padding-bottom: 25px;
}

.foot_bus_zu {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.gywm_but {
  display: flex;
  justify-content: left;
  flex-direction: column;
}

.gywm_but button {
  text-align: left;
}

.yycj_div {
  width: 200px;
  float: left;
}

.yycj_div button {
  text-align: left;
  width: 100px;
  margin: 0;
}

.yycj_div > div {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.foot_HD {
  font-size: 16px;
  font-family: SourceHanSansCN-Medium;
  color: #7981a1;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  height: 38px;
  line-height: 38px;
}

.gywm_but_i {
  margin-right: 10px;
}

.foot_div_B_div_IPDPX {
  color: #edf3fc;
  font-size: 40px;
  text-align: left;
  margin-bottom: 20px;
}

.foot_div_C_textA {
  font-size: 12px;
  font-weight: 500;
  color: #edf3fc;
  line-height: 19px;
}

.foot_div_C_textB {
  font-size: 12px;
  font-weight: 400;
  color: #8b93b0;
  text-align: center;
}

.foot_div_C {
  padding: 50px;
}

.yycj_div_A {
  margin-right: 10px;
}

.yycj_div_text {
  text-align: left;
}
</style>

